import { locationsLoader } from './locations-loader';
export default {
    locationsLoader,
};
